import { defineCustomElement, ref, computed, watch } from 'vue/dist/vue.esm-bundler.js'
import { html } from './shared/functions'

const ImComponent = defineCustomElement({
  props: {
    status: {
      type: String,
      default: ''
    },
  },
  setup(props, { emit }) {
    return {
      status: computed(() => props.status),
    }
  },
  template: html`
  <span v-if="status === 'success'" class="flex items-center justify-center w-8 h-8 rounded-full -start-4 ring-4 ring-white dark:ring-gray-900 bg-green-200 dark:bg-green-900">
    <svg class="w-3.5 h-3.5 text-green-500 dark:text-green-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"></path></svg>
  </span>
  <span v-else class="flex items-center justify-center w-8 h-8 border border-gray-500 rounded-full shrink-0 dark:border-gray-400">
    <slot></slot>
  </span>
`,
},  { shadowRoot: false })

customElements.define('im-step-circle', ImComponent)
